import { render, staticRenderFns } from "./SlotNewDialog.vue?vue&type=template&id=4b807184"
import script from "./SlotNewDialog.vue?vue&type=script&lang=js"
export * from "./SlotNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports